import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-380">
      <div className="max-w-5xl mx-auto" data-id="element-381">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-382">
          Lo que <span className="text-[#B87AFF]" data-id="element-383">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-384">
          <div className="bg-black border border-[#B87AFF]/30 rounded-2xl p-6" data-id="element-385">
            <h3 className="text-[#B87AFF] text-xl font-black mb-2" data-id="element-386">
              🧘 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-387">
              Para profesores de yoga de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-388">
              <div className="flex items-center gap-3 text-white" data-id="element-389">
                <span className="text-xl" data-id="element-390">🟢</span>
                <div className="flex-1" data-id="element-391">
                  <span className="font-bold" data-id="element-392">Tomo 1 — El Despertar</span>
                  <span className="text-gray-300" data-id="element-393">
                    {' '}
                    Inicial (cero experiencia) · 20 secuencias de 60 min · 25
                    asanas base · Fichas de alumno · Planificador anual
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-394">
                <span className="text-xl" data-id="element-395">🟡</span>
                <div className="flex-1" data-id="element-396">
                  <span className="font-bold" data-id="element-397">Tomo 2 — Fluidez Consciente</span>
                  <span className="text-gray-300" data-id="element-398">
                    {' '}
                    Intermedio I (6–12 meses) · Vinyasa completo · 20 secuencias
                    · Progresión al flujo · Chaturanga sin lesión
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-399">
                <span className="text-xl" data-id="element-400">🟠</span>
                <div className="flex-1" data-id="element-401">
                  <span className="font-bold" data-id="element-402">
                    Tomo 3 — El Guerrero Interno
                  </span>
                  <span className="text-gray-300" data-id="element-403">
                    {' '}
                    Intermedio II (12–24 meses) · Inversiones básicas · Peak
                    Pose Method · 20 secuencias con pico de clase
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-404">
                <span className="text-xl" data-id="element-405">🔴</span>
                <div className="flex-1" data-id="element-406">
                  <span className="font-bold" data-id="element-407">Tomo 4 — Maestría y Vuelo</span>
                  <span className="text-gray-300" data-id="element-408">
                    {' '}
                    Avanzado (2+ años) · 15 Masterclasses 90 min · Handstand ·
                    Equilibrios avanzados · Escorpión
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-409">
                <span className="text-xl" data-id="element-410">🟣</span>
                <div className="flex-1" data-id="element-411">
                  <span className="font-bold" data-id="element-412">Tomo 5 — Yoga para la Vida</span>
                  <span className="text-gray-300" data-id="element-413">
                    {' '}
                    Poblaciones especiales · Adultos mayores · Lesiones ·
                    Restaurativo · Yoga terapéutico · Ansiedad
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-414">
                <span className="text-xl" data-id="element-415">⭐</span>
                <div className="flex-1" data-id="element-416">
                  <span className="font-bold" data-id="element-417">Tomo 6 — La Mente en Calma</span>
                  <span className="text-gray-300" data-id="element-418">
                    {' '}
                    Todos los niveles · 60 guiones de meditación · 12 técnicas
                    de pranayama · Filosofía · Gestión
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#B87AFF]/5 border border-[#B87AFF]/30 rounded-2xl p-8 text-center" data-id="element-419">
          <h3 className="text-[#B87AFF] text-xl font-black mb-6" data-id="element-420">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-421">
            <div className="flex items-start gap-2 text-left" data-id="element-422">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-423">✅</span>
              <span className="text-white text-sm" data-id="element-424">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                20–24 secuencias con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-428">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-429">✅</span>
              <span className="text-white text-sm" data-id="element-430">
                Criterios de progresión por nivel y edad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-431">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-432">✅</span>
              <span className="text-white text-sm" data-id="element-433">
                Evaluaciones + rúbricas (escala de observación)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-434">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-435">✅</span>
              <span className="text-white text-sm" data-id="element-436">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-437">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-438">✅</span>
              <span className="text-white text-sm" data-id="element-439">
                Guías técnicas de cada asana con contraindicaciones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-440">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-441">✅</span>
              <span className="text-white text-sm" data-id="element-442">
                Material original EDULABS®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-443">
              <span className="text-[#B87AFF] font-bold flex-shrink-0" data-id="element-444">✅</span>
              <span className="text-white text-sm" data-id="element-445">
                100% aplicable para cualquier profesor de yoga hispanohablante
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}